export type SellerContactDataUi = {
  fullName: string;
  fullNameError?: string;
  phone: string;
  phoneError?: string;
  email: string;
  emailError?: string;
  cancelDisabled: boolean;
  saveDisabled?: boolean;
};

export const initialState: SellerContactDataUi = {
  fullName: '',
  phone: '',
  email: '',
  saveDisabled: true,
  cancelDisabled: true,
};
